export default __webpack_public_path__ + "static/profile-card-kevin-46cf4d6926309ebdaf1dab762f6133dc.png";